import { render } from "./CharactersFavorite.vue?vue&type=template&id=241cd941"
import script from "./CharactersFavorite.vue?vue&type=script&lang=ts"
export * from "./CharactersFavorite.vue?vue&type=script&lang=ts"

import "./CharactersFavorite.vue?vue&type=style&index=0&id=241cd941&lang=scss"
script.render = render

export default script